<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="text-center">
      <p>确定删除退货地址</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="deleteShopReturnAddress">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { deleteShopReturnAddress } from '@/api/goods/shopReturnAddressApi'

export default {
  name: 'DeleteShopReturnAddress',
  data() {
    return {
      dialogVisible: false,
      deleteShopReturnAddressInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteShopReturnAddressInfo = { ...row }
    },
    handleClose() {
      this.deleteShopReturnAddressInfo = {}
    },
    async deleteShopReturnAddress() {
      try {
        const params = {
          ...this.deleteShopReturnAddressInfo,
          shopId: getShopId()
        }
        await deleteShopReturnAddress(params)
        this.$message.success('删除成功')
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除退货地址失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>